import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const deleteProduct = async (placeId, productId) => {
  if (!placeId || !productId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.delete({
    path: `${uri.api}/place/${placeId}/product/${productId}/delete`,
  });
};